import React from 'react';
import { Empty } from 'antd';

export interface KanbanOrder {
  id: string;
  orderId: string;
  name: string;
  status: string;
}

export interface KanbanColumn {
  key: string;
  label: string;
  filterValue: string;
  count: number;
  totalOrderCount: number;
  orders: KanbanOrder[];
  loadedPage: number;
  loadedOrderCount: number;
}

interface KanbanBoardProps {
  columns: KanbanColumn[];
  onColumnClick: (column: KanbanColumn) => void;
  onOrderClick: (order: KanbanOrder) => void;
  loadingColumns: Record<string, boolean>;
  onLoadMore: (column: KanbanColumn) => void;
}

const KanbanBoard: React.FC<KanbanBoardProps> = ({
  columns,
  onColumnClick,
  onOrderClick,
  loadingColumns,
  onLoadMore,
}) => (
  <section className="dashboard-kanban" aria-label="Orders by status">
    {columns.map(column => (
      <div className="kanban-column" key={column.key}>
        <button
          type="button"
          className="kanban-column-header"
          onClick={() => onColumnClick(column)}
          aria-label={`View ${column.label} orders`}
        >
          <span>{column.label}</span>
          <span className="kanban-column-count">{column.count}</span>
        </button>
        <div className="kanban-column-body">
          {column.orders.length ? (
            <>
              {column.orders.map(order => (
                <article className="kanban-order-card" key={order.id}>
                  <button
                    type="button"
                    className="kanban-order-id"
                    onClick={() => onOrderClick(order)}
                    aria-label={`Open order ${order.orderId}`}
                  >
                    {order.orderId}
                  </button>
                  <span className="kanban-order-name">{order.name}</span>
                </article>
              ))}
              {column.loadedOrderCount < column.totalOrderCount && (
                <button
                  type="button"
                  className="kanban-load-more"
                  onClick={() => onLoadMore(column)}
                  disabled={loadingColumns[column.key]}
                >
                  {loadingColumns[column.key] ? 'Loading...' : 'Load more'}
                </button>
              )}
            </>
          ) : (
            <Empty
              className="kanban-empty"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No orders"
            />
          )}
          {!column.orders.length && column.totalOrderCount > 0 && (
            <button
              type="button"
              className="kanban-load-more"
              onClick={() => onLoadMore(column)}
              disabled={loadingColumns[column.key]}
            >
              {loadingColumns[column.key] ? 'Loading...' : 'Load more'}
            </button>
          )}
        </div>
      </div>
    ))}
  </section>
);

export default KanbanBoard;
